import { render, staticRenderFns } from "./InputBox.vue?vue&type=template&id=777ad638&"
import script from "./InputBox.vue?vue&type=script&lang=js&"
export * from "./InputBox.vue?vue&type=script&lang=js&"
import style0 from "./InputBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('777ad638')) {
      api.createRecord('777ad638', component.options)
    } else {
      api.reload('777ad638', component.options)
    }
    module.hot.accept("./InputBox.vue?vue&type=template&id=777ad638&", function () {
      api.rerender('777ad638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/commRecord/components/InputBox.vue"
export default component.exports